import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import { Observable, throwError, of as _observableOf } from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";
import { RestResponse } from "../models/RestResponse";
import { AuthTokenService } from "./auth-token.service";
import { BlockUIService } from "./blockui.service";
//import Swal from 'sweetalert2/dist/sweetalert2.js'
import Swal from "sweetalert2/dist/sweetalert2.all.js";
import { Router } from "@angular/router";
import { QueryModel } from "../models/queryModel";

export const API_BASE_URL = new InjectionToken<string>("API_BASE_URL");

@Injectable()
export class RestClientService {
  private httpClient: HttpClient;

  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    private authService: AuthTokenService,
    private blockUI: BlockUIService,
    private router: Router,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.httpClient = http;
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  getHeaders(isSecure: boolean) {
    if (isSecure) {
      var tokenKey = this.authService.getToken();
      return new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${tokenKey}`,
      });
    } else {
      return new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      });
    }
  }
  getAuthorization() {
    var queryModel = new QueryModel();
    if (this.authService.getToken()) {
      var authorization = this.authService.getToken();

      queryModel.authorise_link = authorization.token_link;
      queryModel.authorise_token = authorization.token;
    }
    return queryModel;
  }

  HttpGet(
    subUrl: string,
    isSecure: boolean = true,
    isBlockUI: boolean = true
  ): Observable<any> {
    if (isBlockUI) {
      this.blockUI.startBlock();
      // console.log(blo);
    }
    let url = this.baseUrl + subUrl;
    url = url.replace(/[?&]$/, "");
    //console.log(url);

    let options_: any = {
      observe: "response",
      responseType: "blob",
    };

    return this.httpClient
      .request("Get", url, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResponse(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          this.blockUI.stopBlock();

          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResponse(<any>response_);
            } catch (e) {
              return <Observable<any>>throwError(e);
            }
          } else return <Observable<any>>throwError(response_);
        })
      );
  }

  HttpPost(
    data: any | null | undefined,
    subUrl: string,
    isSecure: boolean = true,
    isBlockUI: boolean = true
  ): Observable<any> {
    if (isBlockUI) {
      this.blockUI.startBlock();
      //console.log("here");
    }
    let url = this.baseUrl + subUrl;
    url = url.replace(/[?&]$/, "");
    //console.log(url);
    var authorization: QueryModel = this.getAuthorization();
    data.authorise_link = authorization.authorise_link;
    data.authorise_token = authorization.authorise_token;
    //console.log(data)
    const content_ = JSON.stringify(data);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: this.getHeaders(isSecure),
    };

    return this.httpClient
      .request("Post", url, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          //console.log(response_);
          return this.processResponse(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          this.blockUI.stopBlock();

          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResponse(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>throwError(e));
            }
          } else return <Observable<any>>(<any>throwError(response_));
        })
      );
  }

  HttpPut(
    data: any | null | undefined,
    subUrl: string,
    isSecure: boolean = true,
    isBlockUI: boolean = true
  ): Observable<any> {
    if (isBlockUI) {
      this.blockUI.startBlock();
      // console.log(blo);
    }
    let url = this.baseUrl + subUrl;
    url = url.replace(/[?&]$/, "");
    //console.log(url);
    var authorization: QueryModel = this.getAuthorization();
    data.authorise_link = authorization.authorise_link;
    data.authorise_token = authorization.authorise_token;
    const content_ = JSON.stringify(data);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: this.getHeaders(isSecure),
    };

    return this.httpClient
      .request("Put", url, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          //console.log(response_);

          return this.processResponse(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          this.blockUI.stopBlock();

          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResponse(<any>response_);
            } catch (e) {
              return <Observable<any>>(<any>throwError(e));
            }
          } else return <Observable<any>>(<any>throwError(response_));
        })
      );
  }

  HttpDelete(
    subUrl: string,
    isSecure: boolean = true,
    isBlockUI: boolean = true
  ): Observable<void> {
    if (isBlockUI) {
      this.blockUI.startBlock();
      // console.log(blo);
    }
    let url = this.baseUrl + subUrl;
    url = url.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: this.getHeaders(isSecure),
    };

    return this.httpClient
      .request("delete", url, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResponse(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          this.blockUI.stopBlock();

          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResponse(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>throwError(e));
            }
          } else return <Observable<void>>(<any>throwError(response_));
        })
      );
  }

  protected processResponse(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;
    this.blockUI.stopBlock();

    //console.log("blob", responseBlob);
    //console.log("status", status);

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          // _responseText.slice(0, 1);
          // console.log(_responseText)
          if (_responseText[0] == ",") {
            // _responseText = _responseText.slice(1);
            _responseText = _responseText.replace(/^.{1}/g, "{");
            // console.log(_responseText);
          }
          // var responseLength = _responseText.length - 1
          // if (_responseText[responseLength] == '}') {
          //     _responseText = _responseText.slice(responseLength);
          //     console.log(_responseText);
          // }

          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 ? resultData200 : {};

          var result = new RestResponse<any>(result200, _headers);
          return _observableOf(result);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException("Bad Request", status, _responseText, _headers);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          this.authService.clearToken();

          this.router.navigate(["/login"]);

          return throwException(
            "Unauthorized Request",
            status,
            "Invalid User Name Or Password",
            _headers
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "A server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "Resource not found",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<any>(<any>null);
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  // this.blockUI.stopBlockHold();

  if (status == 401) {
    Swal.fire("Error", response, "error");
  }
  //console.log(message)
  //console.log(status)
  //console.log(result)
  // var errorObj = JSON.parse(response);
  Swal.fire("Error", response, "error");

  if (result !== null && result !== undefined) {
    console.error(result);
    return throwError(result);
  } else {
    var error = {
      status: status,
      message: message,
    };
    return throwError(error);
  }
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = function () {
        observer.next(this.result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
